// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer-tooltip,.localeSelector{z-index:1000}.localeSelector .popover-inner{padding:10px 0}.localeSelector .popover-arrow{display:none}.localeSelector .popover:focus{outline:0}", ""]);
// Exports
module.exports = exports;
